import { routerPostCall } from '../../axios';

const setPassword = (state, params) => {
  const url = `/auth/password/set`;
  return routerPostCall(state, url, params);
};
export default { setPassword };
